import {
  FileText,
  Package,
  LayoutGrid,
  Search,
  ShoppingCart,
  MinusCircle,
  ShoppingBag,
  CreditCard,
  CheckCircle,
  Zap,
  type LucideIcon,
} from 'lucide-react';

export type EventType =
  | 'page_viewed'
  | 'product_viewed'
  | 'collection_viewed'
  | 'search_submitted'
  | 'product_added_to_cart'
  | 'product_removed_from_cart'
  | 'cart_viewed'
  | 'checkout_started'
  | 'checkout_completed'
  | 'custom';

export const EVENT_ICONS: Record<EventType, LucideIcon> = {
  page_viewed: FileText,
  product_viewed: Package,
  collection_viewed: LayoutGrid,
  search_submitted: Search,
  product_added_to_cart: ShoppingCart,
  product_removed_from_cart: MinusCircle,
  cart_viewed: ShoppingBag,
  checkout_started: CreditCard,
  checkout_completed: CheckCircle,
  custom: Zap,
};

export const EVENT_COLORS: Record<EventType, string> = {
  page_viewed: 'text-slate-600 bg-slate-100',
  product_viewed: 'text-blue-600 bg-blue-100',
  collection_viewed: 'text-purple-600 bg-purple-100',
  search_submitted: 'text-amber-600 bg-amber-100',
  product_added_to_cart: 'text-green-600 bg-green-100',
  product_removed_from_cart: 'text-red-600 bg-red-100',
  cart_viewed: 'text-orange-600 bg-orange-100',
  checkout_started: 'text-indigo-600 bg-indigo-100',
  checkout_completed: 'text-emerald-600 bg-emerald-100',
  custom: 'text-gray-600 bg-gray-100',
};

export const EVENT_LABELS: Record<EventType, string> = {
  page_viewed: 'Page Viewed',
  product_viewed: 'Product Viewed',
  collection_viewed: 'Collection Viewed',
  search_submitted: 'Search',
  product_added_to_cart: 'Added to Cart',
  product_removed_from_cart: 'Removed from Cart',
  cart_viewed: 'Cart Viewed',
  checkout_started: 'Checkout Started',
  checkout_completed: 'Checkout Completed',
  custom: 'Custom Event',
};
